import React, { useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as source from "sources/books/tripScenarios";
import Form from "./form";
import List from "./list";
import Show from "./show";

const TripScenarios = (props) => {
    useEffect(() => {
        return () => props.clearParams("trip-scenarios");
    }, []);

    const { match, location, history, canEditBooks } = props;
    const rootUrl = `${match.path}/list`;
    const back = () => history.push(rootUrl);
    return (
        <div className="page-content">
            <Switch location={location}>
                <Route exact path={`${match.path}/`} render={() => <Redirect to={rootUrl} />} />
                <Route
                    exact
                    path={rootUrl}
                    render={() => (
                        <List
                            {...props}
                            isTable
                            transition="full"
                            title="Список опросов в рейсе"
                            nofilter
                            createBtnText="Создать опрос"
                        />
                    )}
                />
                <Route
                    path={`${rootUrl}/:id`}
                    render={(rest) => (
                        <Show {...rest} transition="full" title="Опрос в рейсе" back={back} source={source} />
                    )}
                />
                {canEditBooks() && (
                    <Route
                        path={`${match.path}/new`}
                        render={() => <Form {...props} title="Создать опрос" back={back} submit={source.apply} />}
                    />
                )}
            </Switch>
        </div>
    );
};

export default TripScenarios;
